export const apiConfiguration = { baseApiUrl: '/api' };
